import React from 'react';
import { connect as formikConnect } from 'formik';

const create = errors => {
  let errorIds = new Set();

  for (let key in errors) {
    const value = errors[key];

    if (typeof value === 'string') errorIds.add(key);

    if (Array.isArray(value))
      value.forEach((v, idx) => {
        for (let k in v) errorIds.add(`${key}.${idx}.${k}`);
      });
  }

  return errorIds;
};

class ErrorFocus extends React.Component {
  componentDidUpdate(prevProps) {
    const { isSubmitting, isValidating, errors } = prevProps.formik;

    if (!isSubmitting) return;

    const keys = create(errors);

    if (keys.size > 0 && isSubmitting && !isValidating) {
      const iterator = keys.values();
      const { value } = iterator.next();

      const selector = `[id="${value}"]`;

      const errorElement = document.querySelector(selector);

      if (!errorElement) {
        throw new Error(
          `The error element is not found. Did you put ${value} as your id in the desired input field`
        );
      }

      errorElement.focus();
    }
  }

  render() {
    return null;
  }
}

export default formikConnect(ErrorFocus);



// WEBPACK FOOTER //
// ./src/screens/Flights/PassengerDetails/ErrorFocus.js